import axios from "axios";
const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const instance = axios.create({
  baseURL: SERVER_URL,
  headers: {
    "Accept": "multipart/form-data",
    "Content-type": "application/x-www-form-urlencoded;multipart/form-data; charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
  }
});

instance.interceptors.request.use((config) => {
  let params = config.params || {};
  let browserData = localStorage.getItem('USER_INFO');
  if (browserData != null) {
    let jsonAccess = JSON.parse(browserData);
    let authToken = localStorage.getItem('AUTH_TOKEN');
    const authFields = {
      logged_user_id: jsonAccess.user_id,
      logged_site_id: jsonAccess.site_id,
      auth_token: authToken,
      lang_code: params.lang_code || jsonAccess.lang_code,
    };
    const method = (config.method || 'get').toLowerCase();
    if (method === 'delete') {
      // Some proxies/CDNs strip the body of DELETE requests (no defined semantics
      // per RFC 7231), so send auth via headers too - always forwarded regardless
      // of method, and don't touch the URL like query params do.
      config.headers = config.headers || {};
      config.headers['X-Logged-User-Id'] = authFields.logged_user_id;
      config.headers['X-Logged-Site-Id'] = authFields.logged_site_id;
      config.headers['X-Auth-Token'] = authFields.auth_token;
    }
    if (method === 'post' || method === 'put' || method === 'patch' || method === 'delete') {
      // Send auth fields in request body so they don't appear in URL logs
      // and don't trigger WAF SQL-injection rules on bcrypt hash values
      if (config.data instanceof FormData) {
        if (!config.data.has('logged_user_id')) {
          config.data.append('logged_user_id', authFields.logged_user_id);
        }
        if (!config.data.has('logged_site_id')) {
          config.data.append('logged_site_id', authFields.logged_site_id);
        }
        if (!config.data.has('auth_token')) {
          config.data.append('auth_token', authFields.auth_token);
        }
        if (!config.data.has('lang_code')) {
          config.data.append('lang_code', authFields.lang_code);
        }
      } else {
        const existing = config.data
          ? (typeof config.data === 'string'
              ? Object.fromEntries(new URLSearchParams(config.data))
              : config.data)
          : {};
        const merged = { ...authFields, ...existing };
        config.data = new URLSearchParams(merged).toString();
      }
    } else {
      config.params = { ...params, ...authFields };
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default instance;